import React, { useEffect, useState } from 'react';
import { Check, Lock, ShieldCheck, Eye, Clock } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
export function PricingBundle() {
  const [selectedTier, setSelectedTier] = useState(2); // Default to middle tier
  // Countdown timer state
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 40,
    seconds: 32
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handleSelect = (tier: number) => {
    setSelectedTier(tier);
  };
  const getTierName = () => {
    if (selectedTier === 1) return 'ESENCIAL';
    if (selectedTier === 2) return 'COMPLETO';
    return 'PREMIUM';
  };
  const getTierPrice = () => {
    if (selectedTier === 1) return '17,00';
    if (selectedTier === 2) return '37,00';
    return '57,00';
  };
  const getTierCartUrl = () => {
    if (selectedTier === 1) return 'https://mundodeco.shop/cart/51169504559451:1';
    if (selectedTier === 2) return 'https://mundodeco.shop/cart/52524398412123:1';
    return 'https://mundodeco.shop/cart/52532237828443:1';
  };
  const handleAddToCart = () => {
    trackEvent('InitiateCheckout', {
      content_name: `Kit Fiesta Mágica ${getTierName()}`,
      content_category: 'kit_fiesta',
      value: selectedTier === 1 ? 17.0 : selectedTier === 2 ? 37.0 : 57.0,
      currency: 'EUR'
    });
    trackEvent('AddToCart', {
      content_name: `Kit Fiesta Mágica ${getTierName()}`,
      content_type: 'product',
      value: selectedTier === 1 ? 17.0 : selectedTier === 2 ? 37.0 : 57.0,
      currency: 'EUR'
    });
  };
  return <section id="pricing" className="py-16 px-4 bg-[#b5e5e0] relative overflow-hidden font-nunito" data-id="element-166">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-167">
        {/* Product Cover Image */}
        <div className="flex justify-center mb-8" data-id="element-168">
          <img src="https://cdn.magicpatterns.com/uploads/wX3CVhigrcipp98aax3QFZ/Diseno_sin_titulo_(3).png" alt="Kit Fiesta Mágica - Portada del producto" className="w-full max-w-sm rounded-3xl shadow-xl border-4 border-white" data-id="element-169" />
        </div>

        <div className="space-y-8 mb-8" data-id="element-170">
          {/* TIER 1 - ESENCIAL */}
          <div onClick={() => handleSelect(1)} className={`cursor-pointer rounded-3xl transition-all duration-300 bg-white border-4 ${selectedTier === 1 ? 'border-pink-500 shadow-lg scale-[1.02]' : 'border-transparent shadow-md hover:border-pink-200'}`} data-id="element-171">
            <div className="p-6" data-id="element-172">
              <div className="flex justify-between items-start mb-4" data-id="element-173">
                <div data-id="element-174">
                  <h3 className="text-xl font-bold text-gray-900 font-baloo leading-tight flex items-center gap-2" data-id="element-175">
                    <span data-id="element-176">⚡</span> KIT FIESTA MÁGICA
                    <br data-id="element-177" />
                    ESENCIAL
                  </h3>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-178">
                    La base perfecta para tu fiesta
                  </p>
                </div>
                <div className="text-right" data-id="element-179">
                  <div className="text-4xl font-bold text-pink-500 font-baloo" data-id="element-180">
                    €17,00
                  </div>
                </div>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-181"></div>

              <div data-id="element-182">
                <p className="text-pink-500 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-183">
                  <span data-id="element-184">📦</span> INCLUYE:
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-185">
                  <li className="flex items-start gap-2" data-id="element-186">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-187" />
                    <span data-id="element-188">+10,000 plantillas imprimibles listas para usar</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-189">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-190" />
                    <span data-id="element-191">10 bonos exclusivos incluidos</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* TIER 2 - COMPLETO (HIGHLIGHTED) */}
          <div onClick={() => handleSelect(2)} className={`cursor-pointer rounded-3xl transition-all duration-300 bg-white border-4 relative ${selectedTier === 2 ? 'border-pink-500 shadow-xl scale-[1.02]' : 'border-pink-300 shadow-md hover:border-pink-400'}`} data-id="element-192">
            {/* Recommended Badge */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-pink-400 text-white text-sm font-bold px-6 py-1.5 rounded-full shadow-sm flex items-center gap-2 whitespace-nowrap" data-id="element-193">
              <span data-id="element-194">⭐</span> MÁS RECOMENDADO
            </div>

            <div className="p-6 pt-8" data-id="element-195">
              <div className="flex justify-between items-start mb-4" data-id="element-196">
                <div data-id="element-197">
                  <h3 className="text-xl font-bold text-gray-900 font-baloo leading-tight flex items-center gap-2" data-id="element-198">
                    <span data-id="element-199">🏆</span> KIT FIESTA MÁGICA
                    <br data-id="element-200" />
                    COMPLETO
                  </h3>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-201">
                    Todo el Esencial + Video Curso
                    <br data-id="element-202" />
                    paso a paso
                  </p>
                </div>
                <div className="text-right flex flex-col items-end" data-id="element-203">
                  <div className="text-4xl font-bold text-pink-500 font-baloo leading-none mb-1" data-id="element-204">
                    €37,00
                  </div>
                  <div className="text-gray-400 line-through text-sm font-bold mb-1" data-id="element-205">
                    €67,00
                  </div>
                  <div className="bg-pink-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-206">
                    <span data-id="element-207">🔥</span> AHORRA 44%
                  </div>
                </div>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-208"></div>

              <div className="mb-4" data-id="element-209">
                <p className="text-pink-500 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-210">
                  <span data-id="element-211">📦</span> INCLUYE TODO EL ESENCIAL, MÁS:
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-212">
                  <li className="flex items-start gap-2" data-id="element-213">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-214" />
                    <span data-id="element-215">+10,000 plantillas imprimibles</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-216">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-217" />
                    <span data-id="element-218">10 bonos exclusivos</span>
                  </li>
                </ul>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-219"></div>

              <div data-id="element-220">
                <p className="text-gray-800 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-221">
                  <span data-id="element-222">🎬</span> Video Curso — aprende cómo hacer:
                </p>
                <div className="grid grid-cols-2 gap-x-2 gap-y-2 text-xs text-gray-600" data-id="element-223">
                  <div className="flex items-start gap-1.5" data-id="element-224">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-225" />
                    <span data-id="element-226">Invitaciones en Canva</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-227">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-228" />
                    <span data-id="element-229">Diseño de stickers</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-230">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-231" />
                    <span data-id="element-232">Libritos de colorear</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-233">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-234" />
                    <span data-id="element-235">Personalizar plantillas</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-236">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-237" />
                    <span data-id="element-238">Trabajar desde celular</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-239">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-240" />
                    <span data-id="element-241">Armar papelería creativa</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-242">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-243" />
                    <span data-id="element-244">Archivos para Cricut</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-245">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-246" />
                    <span data-id="element-247">Silhouette y plotter</span>
                  </div>
                </div>
              </div>

              {/* Selection Indicator */}
              {selectedTier === 2 && <div className="mt-6 bg-pink-500 text-white text-center py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2" data-id="element-248">
                  <div className="w-4 h-4 bg-white rounded-sm flex items-center justify-center" data-id="element-249">
                    <Check className="w-3 h-3 text-pink-500" data-id="element-250" />
                  </div>
                  SELECCIONADO — KIT FIESTA MÁGICA COMPLETO
                </div>}
            </div>
          </div>

          {/* TIER 3 - PREMIUM */}
          <div onClick={() => handleSelect(3)} className={`cursor-pointer rounded-3xl transition-all duration-300 bg-white border-4 ${selectedTier === 3 ? 'border-pink-500 shadow-lg scale-[1.02]' : 'border-transparent shadow-md hover:border-pink-200'}`} data-id="element-251">
            <div className="p-6" data-id="element-252">
              <div className="flex justify-between items-start mb-4" data-id="element-253">
                <div data-id="element-254">
                  <h3 className="text-xl font-bold text-gray-900 font-baloo leading-tight flex items-center gap-2" data-id="element-255">
                    <span data-id="element-256">👑</span> KIT FIESTA MÁGICA
                    <br data-id="element-257" />
                    PREMIUM
                  </h3>
                  <p className="text-gray-500 text-sm mt-1" data-id="element-258">
                    El paquete más completo — TODO
                    <br data-id="element-259" />
                    incluido
                  </p>
                </div>
                <div className="text-right flex flex-col items-end" data-id="element-260">
                  <div className="text-4xl font-bold text-pink-500 font-baloo leading-none mb-1" data-id="element-261">
                    €57,00
                  </div>
                  <div className="text-gray-400 line-through text-sm font-bold mb-1" data-id="element-262">
                    €76,04
                  </div>
                  <div className="bg-pink-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-263">
                    <span data-id="element-264">🔥</span> AHORRA 25%
                  </div>
                </div>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-265"></div>

              <div className="mb-4" data-id="element-266">
                <p className="text-pink-500 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-267">
                  <span data-id="element-268">👑</span> INCLUYE TODO EL COMPLETO, MÁS:
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-269">
                  <li className="flex items-start gap-2" data-id="element-270">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-271" />
                    <span data-id="element-272">+10,000 plantillas imprimibles</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-273">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-274" />
                    <span data-id="element-275">10 bonos exclusivos</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-276">
                    <Check className="w-4 h-4 text-pink-500 mt-0.5 flex-shrink-0" data-id="element-277" />
                    <span data-id="element-278">Video Curso paso a paso completo</span>
                  </li>
                </ul>
              </div>

              <div className="border-t border-dashed border-pink-200 my-4" data-id="element-279"></div>

              <div data-id="element-280">
                <p className="text-gray-800 font-bold text-sm mb-3 flex items-center gap-2" data-id="element-281">
                  <span data-id="element-282">💎</span> Contenido exclusivo Premium:
                </p>
                <div className="grid grid-cols-2 gap-x-2 gap-y-2 text-xs text-gray-600" data-id="element-283">
                  <div className="flex items-start gap-1.5" data-id="element-284">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-285" />
                    <span data-id="element-286">Plantillas de Halloween</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-287">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-288" />
                    <span data-id="element-289">Plantillas de Navidad</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-290">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-291" />
                    <span data-id="element-292">Diseños para sublimación</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-293">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-294" />
                    <span data-id="element-295">Diseños para iPhone</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-296">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-297" />
                    <span data-id="element-298">Invitaciones digitales extra</span>
                  </div>
                  <div className="flex items-start gap-1.5" data-id="element-299">
                    <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 flex-shrink-0" data-id="element-300" />
                    <span data-id="element-301">Guía para emprender</span>
                  </div>
                </div>
              </div>

              {/* Selection Indicator */}
              {selectedTier === 3 && <div className="mt-6 bg-pink-500 text-white text-center py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2" data-id="element-302">
                  <div className="w-4 h-4 bg-white rounded-sm flex items-center justify-center" data-id="element-303">
                    <Check className="w-3 h-3 text-pink-500" data-id="element-304" />
                  </div>
                  SELECCIONADO — KIT FIESTA MÁGICA PREMIUM
                </div>}
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mb-6" data-id="element-305">
          <a href={getTierCartUrl()} target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full bg-pink-500 text-white font-baloo font-bold text-xl py-4 px-6 rounded-2xl shadow-[0_6px_0_#D81B60] hover:shadow-[0_3px_0_#D81B60] hover:translate-y-[3px] transition-all duration-200 flex flex-col items-center justify-center gap-1 no-underline" data-id="element-306">
            <span data-id="element-307">🛒 AÑADIR AL CARRITO — KIT {getTierName()}</span>
            <span className="text-xs font-normal flex items-center gap-1 opacity-90" data-id="element-308">
              <span data-id="element-309">⚡</span> Acceso inmediato por email tras la compra
            </span>
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex justify-center items-center gap-3 text-xs text-gray-500 font-medium mb-10" data-id="element-310">
          <div className="flex items-center gap-1" data-id="element-311">
            <Lock className="w-3 h-3 text-orange-400" data-id="element-312" /> Pago seguro
          </div>
          <span data-id="element-313">·</span>
          <div data-id="element-314">Sin suscripciones</div>
          <span data-id="element-315">·</span>
          <div data-id="element-316">Pago único</div>
        </div>

        {/* Urgency & Countdown Section */}
        <div className="space-y-4" data-id="element-317">
          {/* Urgency Indicators */}
          <div className="bg-white rounded-2xl p-4 shadow-sm" data-id="element-318">
            <div className="flex justify-between items-center mb-3" data-id="element-319">
              <div className="flex items-center gap-2 text-sm font-bold text-gray-700" data-id="element-320">
                <span data-id="element-321">🔥</span> Accesos disponibles hoy
              </div>
              <div className="text-pink-500 font-bold text-sm" data-id="element-322">9 restantes</div>
            </div>
            {/* Progress bar */}
            <div className="w-full bg-gray-100 rounded-full h-2 mb-3" data-id="element-323">
              <div className="bg-pink-500 h-2 rounded-full w-[85%]" data-id="element-324"></div>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-325">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" data-id="element-326"></div>
              11 personas están viendo esto ahora mismo
            </div>
          </div>

          {/* Countdown Timer */}
          <div className="bg-white rounded-3xl p-6 shadow-sm border-2 border-pink-50 text-center" data-id="element-327">
            <div className="flex items-center justify-center gap-2 text-pink-500 font-bold text-sm mb-4" data-id="element-328">
              <span data-id="element-329">⚡</span> OFERTA ESPECIAL EXPIRA EN
            </div>

            <div className="flex justify-center items-center gap-2 mb-6" data-id="element-330">
              {/* Hours */}
              <div className="flex flex-col items-center" data-id="element-331">
                <div className="bg-pink-500 text-white font-baloo text-4xl font-bold w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-332">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <span className="text-[10px] font-bold text-gray-400 mt-2 tracking-wider" data-id="element-333">
                  HORAS
                </span>
              </div>

              <div className="text-pink-300 text-2xl font-bold pb-6" data-id="element-334">:</div>

              {/* Minutes */}
              <div className="flex flex-col items-center" data-id="element-335">
                <div className="bg-pink-500 text-white font-baloo text-4xl font-bold w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-336">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <span className="text-[10px] font-bold text-gray-400 mt-2 tracking-wider" data-id="element-337">
                  MINUTOS
                </span>
              </div>

              <div className="text-pink-300 text-2xl font-bold pb-6" data-id="element-338">:</div>

              {/* Seconds */}
              <div className="flex flex-col items-center" data-id="element-339">
                <div className="bg-pink-500 text-white font-baloo text-4xl font-bold w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-340">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <span className="text-[10px] font-bold text-gray-400 mt-2 tracking-wider" data-id="element-341">
                  SEGUNDOS
                </span>
              </div>
            </div>

            <div className="flex items-center justify-center gap-1.5 text-sm text-gray-600 mb-4" data-id="element-342">
              <Lock className="w-3.5 h-3.5 text-orange-400" data-id="element-343" />
              Precio bloqueado en{' '}
              <span className="font-bold text-pink-500" data-id="element-344">
                €{getTierPrice()}
              </span>{' '}
              solo por hoy
            </div>

            <div className="bg-pink-400 text-white font-bold py-3 px-4 rounded-xl text-sm shadow-sm flex items-center justify-center gap-2" data-id="element-345">
              <span data-id="element-346">🎉</span> Ahorra hasta un 60% ¡Oferta válida hoy!
            </div>
          </div>
        </div>
      </div>
    </section>;
}